import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-paper min-h-[80vh] flex items-center" data-testid="login-page">
      <div className="max-w-md mx-auto w-full px-6 py-20">
        <p className="text-xs uppercase tracking-[0.22em] text-terracotta mb-6">
          Author Sign In
        </p>
        <h1 className="font-serif-display text-3xl lg:text-4xl tracking-tight text-ink leading-tight">
          The writing <span className="italic">desk.</span>
        </h1>
        <p className="mt-4 text-ink-soft text-sm">
          For Barbara to add, edit, and publish her writings.
        </p>

        <form onSubmit={onSubmit} className="mt-10 space-y-6" data-testid="login-form">
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-ink-soft mb-2">
              Email
            </label>
            <input
              type="email"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
              className="w-full bg-transparent border-b border-rule focus:border-ink py-3 outline-none text-ink"
              placeholder="barbara@bruffwrites.com"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-ink-soft mb-2">
              Password
            </label>
            <input
              type="password"
              value={password}
              required
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              className="w-full bg-transparent border-b border-rule focus:border-ink py-3 outline-none text-ink"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p className="text-sm text-terracotta" data-testid="login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full py-3 bg-terracotta text-paper text-sm tracking-[0.18em] uppercase hover:bg-ink transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
